import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel, CircularProgress,
  LinearProgress,
} from "@mui/material";
import Logo from "../../assets/images/spirnexs-logo-white.webp";
import PhoneImage from "../../assets/images/mobileInhnad.png";
import Transportation from "../../assets/images/global-logistics-transportation-network.png";

import React, { useEffect, useState } from "react";
import CustomTextField from '../common/CustomTextField';
import CustomButton from '../common/CustomButton';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { SaveRounded } from '@mui/icons-material';
import { REGISTER_PATH, VERIFY_OTP } from '../../services/apiRoutes'
import { genericPost } from '../../services/authServices';
import MessageBox from '../common/CustomMessageBox'
import CustomPasswordFeild from "../common/CustomPasswordFeild";
import CustomMobileField from "../common/CustomMobileField";
import { getCountries } from "../../services/CommonServices";
import { useNavigate } from "react-router-dom";

const SignupPage = () => {

  // Validation Schema
  const validationSchema = Yup.object({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().email('Invalid email address').required('Email is required'),
    mobile: Yup.string().required('Mobile Number is required'),
    password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),

  });

  const otpSchema = Yup.object({
    otp: Yup.string()
      .length(6, "OTP must be 6 digits")
      .required("OTP required"),
  });

  const navigate = useNavigate();

  const [conutries, setConutries] = useState([]);
  const [showOtp, setShowOtp] = useState(false);
  const [savedFormData, setSavedFormData] = useState(null);
  const [generatedOtp, setGeneratedOtp] = useState("");


  const [message, setMessage] = useState({
    open: false,
    text: '',
    type: ''
  })

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    phonecodeId: '',
    password: '',
  };


  /* -------- GENERATE RANDOM 6 DIGIT OTP -------- */
  const generateOtp = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };

  /* -------- SEND OTP TO BACKEND -------- */
  const sendOtp = async (email, otp) => {
    try {

      const payload = {
        email,
        generateOtp: otp,
      };
      const response = await genericPost(VERIFY_OTP, payload);
      // ✅ Handle backend response properly
      if (response?.status === 200) {
        setMessage({
          open: true,
          text: response?.data?.message || "OTP sent to your email address",
          type: "success",
        });
        return response.data;
      }
      // ❌ Handle unexpected success response
      throw new Error("Unexpected server response");
    } catch (error) {
      console.error("Send OTP Error:", error);
      setMessage({
        open: true,
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to send OTP",
        type: "error",
      });
    }
  };


  /* -------- STEP 1: REGISTER (GENERATE & SEND OTP) -------- */
  const handleRegister = async (values, { setSubmitting }) => {
    try {
      const otp = generateOtp();

      // Save locally for later verification
      setGeneratedOtp(otp);
      setSavedFormData(values);
      setShowOtp(true);

      await sendOtp(values.email, otp);

      console.log("Generated OTP:", otp); // optional for debugging
    } catch (err) {
      setMessage({
        open: true,
        text: "Registration failed",
        type: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  /* -------- STEP 2: VERIFY OTP -------- */
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (values.otp !== generatedOtp) {
        setMessage({
          open: true,
          text: "Invalid OTP",
          type: "error",
        });
        return;
      }

      const response = await genericPost(REGISTER_PATH, savedFormData);

      switch (response.status) {
        case 200:
          setMessage({
            open: true,
            text: "Registration successful",
            type: "success",
          });
          setTimeout(() => {
            navigate("/");
          }, 3000);
          break;
        case 400:
          setMessage({ open: true, text: response.data?.message || "Bad request", type: "error" });
          break;
        case 401:
          setMessage({ open: true, text: "Unauthorized access", type: "error" });
          break;
        case 409:
          setMessage({ open: true, text: "User already exists", type: "error" });
          break;
        default:
          setMessage({ open: true, text: "Something went wrong", type: "error" });
      }
    } catch (error) {
      const status = error?.response?.status;
      const apiMessage = error?.response?.data?.message;
      setMessage({
        open: true,
        text: apiMessage || (status === 500 ? "Server error. Please try again later." : "Registration failed"),
        type: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  /* -------- OTP RESEND FUNCTION -------- */
  const handleResendOtp = async () => {
    if (!savedFormData?.email) return;

    const newOtp = generateOtp();
    setGeneratedOtp(newOtp);
    await sendOtp(savedFormData.email, newOtp);

    console.log("Resent OTP:", newOtp); // optional for debugging
  };

  const getCommonData = async () => {
    const getConutriesData = await getCountries()
    setConutries(getConutriesData)
  }
  useEffect(() => {
    getCommonData()
  }, [])


  return (
    <>
      {/* ================= REGISTER FORM ================= */}
      {!showOtp && (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleRegister}

        >
          {({ errors, touched, isSubmitting, values, setFieldValue }) => (
            <Form>
              <Box sx={styles.page}>
                <Box sx={styles.overlayImage} />
                <Box sx={styles.header}>
                  <img src={Logo} alt="logo" style={{ height: 42 }} />
                </Box>
                <Grid container sx={styles.mainContainer}>
                  <Grid item md={6} xs={12} sx={styles.leftPanel}>
                    <Typography sx={styles.bigHeading}>
                      Start Your
                    </Typography>
                    <Typography sx={styles.subHeading}>
                      Journey In Seconds.
                    </Typography>
                    <Box
                      component="img"
                      src={PhoneImage}
                      alt="phone"
                      sx={styles.phoneImg}
                    />
                  </Grid>
                  <Grid item md={6} xs={12} sx={styles.rightPanel}>
                    <Box sx={styles.glassCard}>
                      <Typography sx={styles.formTitle}>
                        Create an account
                      </Typography>
                      <Typography sx={styles.loginText}>
                        Already have an account?{" "}
                        <span
                          style={{ textDecoration: "underline", cursor: "pointer" }}
                          onClick={() => navigate("/")}
                        >
                          Log in
                        </span>

                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Field
                            name="firstName"
                            as={CustomTextField}
                            placeholder="Enter First Name"
                            fullWidth
                            error={touched.firstName && !!errors.firstName}
                            helperText={touched.firstName && errors.firstName}
                            sx={textFieldStyle}
                          />

                        </Grid>
                        <Grid item xs={6}>
                          <Field
                            name="lastName"
                            as={CustomTextField}
                            placeholder="Enter Last Name"
                            fullWidth
                            error={touched.lastName && !!errors.lastName}
                            helperText={touched.lastName && errors.lastName}
                            sx={textFieldStyle}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            name="email"
                            type="email"
                            as={CustomTextField}
                            placeholder="Enter Email"
                            fullWidth
                            error={touched.email && !!errors.email}
                            helperText={touched.email && errors.email}
                            sx={textFieldStyle}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            type="number"
                            name="mobile"
                            as={CustomMobileField}
                            placeholder="Enter Mobile Number"
                            fullWidth
                            error={touched.mobile && !!errors.mobile}
                            helperText={touched.mobile && errors.mobile}
                            countryCode={conutries.find((c) => c.id === values.phonecodeId)}
                            setFieldValue={setFieldValue}
                            sx={textFieldStyle}
                          />

                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            name="password"
                            type="password"
                            as={CustomPasswordFeild}
                            placeholder="Enter Password"
                            fullWidth
                            error={touched.password && !!errors.password}
                            helperText={touched.password && errors.password}
                            sx={textFieldStyle} />
                        </Grid>

                      </Grid>
                      <FormControlLabel
                        sx={{ mt: 2 }}
                        control={<Checkbox sx={{ color: "#fff" }} />}
                        label="I agree to the Terms & Conditions"
                      />

                      <CustomButton
                        sx={styles.button}
                        type="submit"
                        title={
                          isSubmitting ? (
                            <>
                              <CircularProgress size={20} color="inherit" />
                              <span style={{ marginLeft: 10 }}>
                                Create account
                              </span>
                            </>
                          ) : (
                            <span style={{}}>
                              Create account
                            </span>
                          )
                        }
                        size="small"
                        variant="contained"
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>

            </Form>
          )}
        </Formik>
      )}


      {/* ================= OTP FORM (GLASS UI SAME AS SIGNUP) ================= */}
      {
        showOtp && (
          <Formik
            initialValues={{ otp: "" }}
            validationSchema={otpSchema}
            onSubmit={handleSubmit}
          >
            {({ errors, touched, isSubmitting }) => (
              <Form>
                <Box sx={styles.page}>
                  <Box sx={styles.overlayImage} />

                  {/* HEADER */}
                  <Box sx={styles.header}>
                    <img src={Logo} alt="logo" style={{ height: 42 }} />
                  </Box>

                  <Grid container sx={styles.mainContainer}>

                    {/* LEFT SIDE SAME */}
                    <Grid item md={6} xs={12} sx={styles.leftPanel}>
                      <Typography sx={styles.bigHeading}>
                        Verify Your
                      </Typography>
                      <Typography sx={styles.subHeading}>
                        Account Securely.
                      </Typography>

                      <Box
                        component="img"
                        src={PhoneImage}
                        alt="phone"
                        sx={styles.phoneImg}
                      />
                    </Grid>

                    {/* RIGHT SIDE OTP CARD */}
                    <Grid item md={6} xs={12} sx={styles.rightPanel}>
                      <Box sx={styles.glassCard}>

                        <Typography sx={styles.formTitle}>
                          Verify OTP
                        </Typography>

                        <Typography sx={styles.loginText}>
                          Enter the OTP sent to your email
                        </Typography>

                        {/* EMAIL FIELD */}
                        <Field
                          as={CustomTextField}
                          value={savedFormData?.email}
                          disabled
                          fullWidth
                          sx={textFieldStyle}
                        />

                        {/* OTP FIELD */}
                        <Field
                          name="otp"
                          as={CustomTextField}
                          placeholder="Enter 6 digit OTP"
                          error={touched.otp && !!errors.otp}
                          helperText={touched.otp && errors.otp}
                          fullWidth
                          sx={textFieldStyle}
                        />

                        {/* BUTTONS */}
                        <Grid
                          container
                          spacing={2}
                          sx={{ mt: 2 }}
                          alignItems="center"
                        >
                          <Grid item xs={6}>
                            <CustomButton
                              fullWidth
                              type="submit"
                              title={
                                isSubmitting ? (
                                  <CircularProgress size={20} color="inherit" />
                                ) : (
                                  "Verify OTP"
                                )
                              }
                            />
                          </Grid>

                          <Grid item xs={6}>
                            <CustomButton
                              fullWidth
                              type="button"
                              title="Resend OTP"
                              onClick={handleResendOtp}
                            />
                          </Grid>
                        </Grid>

                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        )
      }
      <MessageBox
        open={message.open}
        onClose={() => setMessage({ ...message, open: false })}
        message={message.text}
        type={message.type}
      />
    </>
  );
};


export default SignupPage;
//////////////////////////////////////////////////////// 🎨 STYLES
const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    overflow: "hidden",
    position: "relative",
    background: "linear-gradient(45deg, #5C03DE 0%, #007BFF 50%, #5C03DE 100%)",
    display: "flex",
    flexDirection: "column",
  },

  overlayImage: {
    position: "absolute",
    inset: 0,
    backgroundImage: `url(${Transportation})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    mixBlendMode: "luminosity",
    opacity: 0.9,
    filter: "blur(2px)",
    zIndex: 0,
  },

  header: {
    zIndex: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: { xs: "20px", md: "25px 60px" },
  },

  progressWrapper: {
    width: { xs: "45%", md: "30%" },
  },

  progressBar: {
    height: 5,
    borderRadius: 20,
    backgroundColor: "rgba(255,255,255,0.25)",
    "& .MuiLinearProgress-bar": {
      backgroundColor: "#fff",
    },
  },
  mainContainer: {
    flex: 1,
    maxWidth: "1250px",
    width: "100%",
    margin: "auto",
    alignItems: "center",
    zIndex: 2,
  },
  //////////////////////////////////////////////////////
  // LEFT SIDE
  //////////////////////////////////////////////////////
  leftPanel: {
    color: "#fff",
    paddingLeft: { md: "60px" },
    display: { xs: "none", md: "flex" },
    flexDirection: "column",
    justifyContent: "center",
  },

  bigHeading: {
    fontSize: "64px",
    fontWeight: 700,
    lineHeight: 1.05,
  },
  subHeading: {
    fontSize: "30px",
    opacity: 0.95,
    marginBottom: "40px",
  },
  phoneImg: {
    width: "70%",
    maxWidth: "360px",
  },
  //////////////////////////////////////////////////////
  // RIGHT SIDE
  //////////////////////////////////////////////////////
  rightPanel: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: { xs: "20px", md: "0" },
  },

  glassCard: {
    width: "100%",
    maxWidth: "460px",
    padding: "25px 50px",
    borderRadius: "22px",
    color: "#fff",
    backdropFilter: "blur(25px)",
    boxShadow: "0 15px 40px rgba(0,0,0,0.25)",
    background: "linear-gradient(148deg, rgba(108, 135, 242, 0.8), rgba(160, 90, 238, 0.8))",

  },

  formTitle: {
    fontSize: "26px",
    fontWeight: 700,
    marginBottom: "6px",
  },
  loginText: {
    fontSize: "14px",
    marginBottom: "20px",
    opacity: 0.9,
  },
  input: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      backgroundColor: "rgba(255,255,255,0.92)",
    },
  },
  button: {
    width: "200px",
    height: "55px",
    background: "#2649F1",
    borderRadius: "13px",
    textTransform: "none",
    fontSize: "16px",
    fontWeight: 500,
    color: "#fff",
    "&:hover": {
      background: "#1E3FD1",
    },

    "&:disabled": {
      background: "#2649F1",
      opacity: 0.7,
      color: "#fff",
    },

  },
};
const textFieldStyle = {
  mb: 2,
  backgroundColor: "#fff",

  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",

    "& fieldset": {
      borderColor: "#fff",
    },
    "&:hover fieldset": {
      borderColor: "#fff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fff",
    },
  },

  "& input::placeholder": {
    color: "gray",
    opacity: 1,
  },
};
